module.exports = __webpack_public_path__ + "9dd2da36b5af07e1a775f404992a6ecf.svg";